import React, { useState } from 'react';
import './Tabs.css'; // импортируем CSS
import { useSelector, useDispatch } from 'react-redux'
import { TooltipLabel } from '../../atoms'
import { Castom, Popup, ModalInfo } from '../../organisms'
import { Menu } from '../../pages' 
import { editTitle } from '../../../store/api.js' 
import { useRef } from 'react'; 

export const Tabs = (props) => {
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser) 
  const [activeTab, setActiveTab] = useState(null); 
  const [newOption, setNewOption] = useState([]); 
  //const label1 = rate.subs === 'free'; 
  const label1 = false
  const [title, setTitle] = useState('');  
  const [info, setInfo] = useState('');  
  const [isOpenTitle, setIsOpenTitle] = React.useState(false)  
  const ingRef =  useRef()
 
  React.useEffect(() => {
    if(statusUser === 'resolved' && props.user?.option?.length) { 
      setNewOption(props.user.option);
      const firstTab = props.user.option[0];
      setActiveTab({title: firstTab.title, id: firstTab._id}); // Копируем весь объект настройки
      setTitle(firstTab.title);
    }
  }, [props.user, statusUser]);
  
  
  function handleOpenEdit() {
    setIsOpenTitle(!isOpenTitle);
    setTitle(activeTab?.title || '');
  }

  function handleChange (e) {
    setTitle(e.target.value) 
  } 

  function handleEditTitle(targetId) {
    setIsOpenTitle(!isOpenTitle)  
    setNewOption(prev => {
      const updatedOptions = prev.map(item => 
        item._id === targetId ? { ...item, title } : item
      );
      // Update activeTab if the edited tab is currently active
      if (targetId === activeTab.id) {
        setActiveTab(prevTab => ({ ...prevTab, title }));
      }
      return updatedOptions;
    });
  }
 const handleClick = (title, id, index) => {
   console.log(title, id)
   if(rate.subs === 'free' &&  index ===0) {
    setInfo('Для доступа подключите Стандартную подписку!');
   } if(rate.subs === 'free' &&  index > 0) {
    setInfo('Для доступа подключите Семейную подписку!');
   } else if(rate.subs === 'standart' && index !==0) {
    setInfo('Для доступа подключите Семейную подписку!');
   } else if(rate.subs === 'family' && index > 2) {
    setInfo('Для доступа подключите Премиум подписку!');
   } else {
    setActiveTab({title: title, id: id});
   }
 
 }

 const handleModalClose = () => {
   setInfo('')
 }
  return (
    <>
    {newOption.length > 0 &&
    <section className='castom flexColCenter'> 
    <h2 className='font32EB color'>Параметры меню</h2>
    <p className='font20EB'>Заполните индивидуальные настройки меню</p>
    <div className='form__tabs'>
      {statusUser=== 'resolved' &&
        <div className="tab-container">
          {newOption.map((tab, index) => (
            <div
              key={index}
              className={`tab font20EB colorGrey ${activeTab.id === tab._id ? 'active' : ''} `}
              style={{ "--i": index }}
              onClick={()=> handleClick(tab.title, tab._id, index)}
            >
              {tab.title}
              <span className='gg-edit-castom' onClick={handleOpenEdit}/>
              <Popup isOpen={isOpenTitle} ref={ingRef} type='change-title'>
                <ChangeTitle value={title}  handleChange={handleChange} handleEditTitle={()=> handleEditTitle(tab._id)}/>
              </Popup> 
              {(
              (index === 0 && label1) || 
              (index >= 1 && index <= 2 && (rate.subs === 'standart' || label1)) || 
              (index === 3 && (rate.subs === 'standart' || rate.subs === 'free' || rate.subs === 'family'))
            ) ? (
              <TooltipLabel 
                content={
                  index === 0 ? 'Стандарт' :
                  index >= 1 && index <= 2 ? 'Семейный' :
                  index >= 3 ? 'Премиум' : ''
                } 
                declension='Доступно'
                subcontent={index >= 1 && index <= 2 ? 'и выше' : undefined}
              />
            ) : null} 
            </div>
          ))}
          <div className={`tab tab-option ${props.active === 'index' ? 'active' : ''}`}> 
            <span className='gg-option item__search'/>
            {rate.subs !=='premium' && 
              <TooltipLabel declension='Доступно' content='Премиум' /> 
            }
         
          </div>
        </div>
      }
      <div className="tab-content">
        {Object.values(activeTab).length > 0 &&
            <Castom content={activeTab} label1={label1} user={props.user} infoModal={props.infoModal} title={title}/>
        }
      
      </div>
    </div>
    {info &&
      <ModalInfo textError={info} onClose={handleModalClose}  name="modal-info" />
   
    }
     </section> 
  }
  </>
  );
}; 


export const TabsMenu = (props) => {
  const { currentUser, rate, options, statusUser } = useSelector(state => state.currentUser) 
  const [activeTab, setActiveTab] = useState({});
  
  const label1 = rate.subs === 'free'; 


  React.useEffect(() => {
    if(statusUser === 'resolved' && props.user?.option?.length) { 
      const data = props.user.option[0]
      setActiveTab({title: data.title, id: data._id }) 
  }
  }, [props.user, statusUser]);
  

  function handleEditMenu(tab) {
    props.handleEditMenu({title: tab.title, id: tab._id})
    setActiveTab({title: tab.title, id: tab._id})
  }
  

  return ( 
    <div className='form__tabs'>
      {statusUser=== 'resolved' &&
        <div className="tab-container">
          {props.user.option.map((tab, index) => (
            <div
              key={index}
              className={`tab ${activeTab.id === tab._id ? 'active' : ''}`}
              style={{ "--i": index }}
              onClick={() => handleEditMenu(tab)}
            >
              {tab.title}
        
              {(
              (index === 0 && label1) || 
              (index >= 1 && index <= 2 && (rate.subs === 'standart' || label1)) || 
              (index === 3 && (rate.subs === 'standart' || rate.subs === 'free' || rate.subs === 'family'))
            ) ? (
              <TooltipLabel 
                content={
                  index === 0 ? 'Стандарт' :
                  index >= 1 && index <= 2 ? 'Семейный' :
                  index >= 3 ? 'Премиум' : ''
                } 
                declension='Доступно'
                subcontent={index >= 1 && index <= 2 ? 'и выше' : undefined}
              />
            ) : null} 
            </div>
          ))}
          <div className={`tab tab-option ${props.active === 'index' ? 'active' : ''}`}> 
            <span className='gg-option item__search'/>
            {rate.subs !=='premium' && 
              <TooltipLabel declension='Доступно' content='Премиум' /> 
            }
         
          </div>
        </div>
      }
      {/*<div className="tab-content">
        {Object.values(activeTab).length > 0 &&
            <Menu content={activeTab} label1={label1} infoModal={props.infoModal}/>
        }
      
      </div>*/}
    </div>
   
  );
}; 


const ChangeTitle = (props) => {
  return (
    <div>
      <label className='menu-product__item'>
      <input 
        type='text'
        autoComplete="off" 
        value={props.value || ''}  
        onChange={props.handleChange} 
        placeholder='Изменить название'
        className = {`menu-product__input font14Norm form__input_type_${props.name} ${props.error ? 'form__error' : ''}`} 
        name='title'
        id='title' 
      /> 
      {props.error && <span className="form__text_error font14Norm">{props.error}</span>}
      <button className='gg-ok x-size' onClick={props.handleEditTitle} />
    </label>
    </div>
  )
}